/* eslint-disable react/prop-types */
import React from 'react';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';

import '~styles/modules/match.scss';

const Match = function ({
  candidates, images, answers, questions,
}) {
  // console.log('match-data is', data);
  // go over every candidate and consolidate
  const list = candidates.map((cnd) => {
    let agree = 0;
    let disagree = 0;
    const candAnswers = [
      cnd.q01, cnd.q02, cnd.q03, cnd.q04, cnd.q05,
      cnd.q06, cnd.q07, cnd.q08, cnd.q09, cnd.q10,
      cnd.q11, cnd.q12, cnd.q13, cnd.q14, cnd.q15,
      cnd.q16, cnd.q17, cnd.q18, cnd.q19, cnd.q20,
      cnd.q21, cnd.q22,
    ];
    const qamatch = [];
    for (let i = 0; i < answers.length; i += 1) {
      if (answers[i] != null) {
        // not null
        if (answers[i] === candAnswers[i]) {
          agree += 1;
        } else {
          disagree += 1;
        }
        // true false or null
        qamatch.push(answers[i] === candAnswers[i]);
      } else {
        qamatch.push(null);
      }
    }
    const percentage = (agree + disagree) > 0 ? Math.round((agree / (agree + disagree)) * 100) : 0;
    const candidate = {};
    candidate.shortName = cnd.shortName;
    candidate.percentage = percentage;
    candidate.agree = agree;
    candidate.answeredQ = agree + disagree;
    candidate.img = cnd.img;
    candidate.name = cnd.name;
    candidate.desc = cnd.desc;
    candidate.qamatch = qamatch;
    candidate.text = cnd.resulttext;
    return candidate;
  });
  // order the list here by percentage.
  list.sort((a, b) => ((a.percentage < b.percentage) ? 1 : -1));
  // 'Best Match', 'Best Match (Tied)' or ''
  // find out highest percentage, see the first one
  // console.log(list[0].percentage);

  let bestMatch = 0;
  let bestMatchText = 'Best Match';
  for (let i = 0; i < list.length; i += 1) {
    // find out if there is one match or multiple matches
    if (list[i].percentage === list[0].percentage) {
      bestMatch += 1;
    }
  }
  if (bestMatch > 1) {
    bestMatchText += ' (Tied)';
  }
  for (let i = 0; i < list.length; i += 1) {
    if (list[i].percentage === list[0].percentage) {
      list[i].bestMatch = bestMatchText;
    } else {
      list[i].bestMatch = '';
    }
  }

  const orderdList = list.map((candidate) => {
    const imgSrc = getImage(images.find((image) => image.base === candidate.img));

    // write out which issies you and the candidtae agree/disagree
    const agree = [];
    const disagree = [];

    for (let i = 0; i < candidate.qamatch.length; i += 1) {
      if (candidate.qamatch[i] != null) {
        if (candidate.qamatch[i]) {
        // true, add issue to agree
          agree.push(questions[i].topic);
        } else {
        // true, add issue to disagree
          disagree.push(questions[i].topic);
        }
      }
    }
    const sizeClass = candidate.bestMatch ? 'large circle' : 'small circle';
    const bestMatchBadge = candidate.bestMatch ? <span className="badge bentoncond-n6">{candidate.bestMatch}</span> : <span />;
    const agreeText = agree.length > 0 ? 'Issues you agree on' : '';
    const disagreeText = disagree.length > 0 ? 'Issues you don\'t agree on' : '';
    const agreeListLi = agree.map((topic) => <li className="agree" key={topic.split(' ').join('')}><a href={topic.split(' ').join('').toLowerCase().replace(/^/, '#')} className="bentoncond-n6">{topic}</a></li>);
    const disagreeListLi = disagree.map((topic) => <li className="disagree" key={topic.split(' ').join('')}><a href={topic.split(' ').join('').toLowerCase().replace(/^/, '#')} className="bentoncond-n6">{topic}</a></li>);
    const agreeList = agree.length > 0 ? <ul className="issues">{agreeListLi}</ul> : <span />;
    const disagreeList = disagree.length > 0 ? <ul className="issues">{disagreeListLi}</ul> : <span />;

    return (
      <li key={candidate.shortName}>

        <div className="match-img">
          <div className={sizeClass}>
            <GatsbyImage image={imgSrc} alt={candidate.shortName} layout="fluid" placeholder="blurred" />
          </div>
        </div>
        <div className="match-content">
          <div className="match-pct benton-n6">
            {candidate.percentage}
            % match
            <div className="match-detail bentoncond-n4">
              {bestMatchBadge}
              {candidate.agree}
              {' '}
              out of
              {' '}
              {candidate.answeredQ}
              {' '}
              questions
            </div>
          </div>

          <div className="match-name miller-n6">{candidate.name}</div>
          <div className="match-desc bentoncond-n4">{candidate.desc}</div>
          <p className="match-text body-text">
            {candidate.text}
          </p>
          <p className="bentoncond-n4">
            {agreeText}
          </p>
          {agreeList}
          <p className="bentoncond-n4">
            {disagreeText}
          </p>
          {disagreeList}
        </div>
      </li>
    );
  });

  // click #show-results button to remove `hide` class from .match-results
  function showResults(ev) {
    ev.target.parentNode.classList.remove('hide');
    ev.target.closest('.quiz').classList.remove('noresults');
    document.getElementById('quiz-results').scrollIntoView();
  }

  return (
    <div className="match-results hide" id="quiz-results">
      <button type="button" className="button reveal benton-n6" onClick={showResults}>Show Results</button>
      <div className="match">
        <h3 className="super benton-n6">
          <span className="super--check">
            <StaticImage src="../../assets/images/ticks-color.svg" alt="" />
          </span>
          Boston Mayoral Race
        </h3>
        <h1 className="miller-n6">The results</h1>
        <p className="introtext">
          Here are the candidates in order of who you matched with the most. 
          You can see how they answered each question by
          {' '}
          <a href="#fundingpriority">scrolling up to the question</a>
          {' '}
          or clicking on a policy topic.
          Toggle your answers and see how the matching order changes.
        </p>
        <ul className="candidates">{orderdList}</ul>
      </div>
    </div>

  );
};

export default Match;
